
// Definición de defaults

export const defaultAutoridadAmparo: AutoridadAmparoProps = {
    idAutoridadAmparo: 0,
    descripcion:       '',
    activo:            false,
}

// Creación de interfaces

export interface AutoridadAmparoProps {
    idAutoridadAmparo:         number;
    descripcion:       string;
    activo:            boolean;
}